import gql from 'graphql-tag';

import { AlbumSlideshowPhotosDetails } from '../../../../../../graphql/fragments/album';

const getAlbumSlideshowDesignerOrderPhotos = gql`
  query getAlbumSlideshowDesignerOrderPhotos(
    $album_id: RecordID!
    $limit: Int = 40
    $offset: Int = 0
  ) {
    album(id: $album_id) {
      id
      slideshow {
        ...AlbumSlideshowPhotosDetails
      }
    }
  }
  ${AlbumSlideshowPhotosDetails}
`;

export default getAlbumSlideshowDesignerOrderPhotos;
